import axios from 'axios'
import { getAPIService } from '../../getServerHost'

export const getAvailableRcus = async () => {
  const response = await axios.get(`${getAPIService}/v2/api/rcus?available=true&limit=200&page=1`)
  return response.data
}
